import React, {ChangeEvent} from 'react';
import {ControlButton, TscButtonType, inputTypes, TextInput, TscThemeName} from '@techsmith/tsc-cloud-style-guide';
import {useLocation} from 'react-router';
import {useTranslation} from 'react-i18next';
import StringUtil from '../../util/StringUtil';
import styled from 'styled-components';

// The theme is hardcoded here because this component is currently used on a 'Status' page where
// we are forcing light theme because of legacy assets.  If that ever changes we would use the themeStore here
const formInputTheme = TscThemeName.dawn;
const accessPhraseChallengeFormName = 'access-phrase-challenge';

const InputAccessPhraseForm = styled.form`
   display: flex;
    flex-direction: column;
    align-items: center;
`;

const FormFieldRow = styled.div`
   display: flex;
   justify-content: flex-end;
   margin-top: .5rem;

   > .styled-button {
      width: 15.5rem;
   }

   > .text-input-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: auto;

      input {
         width: 15.5rem;
      }

      > div[class^='TextInput__StyledWarning'] {
         margin-left: 0;
      }
   }
`;

const AccessPhraseInput: React.FC = () => {
   const {t} = useTranslation();
   const location = useLocation();
   const [accessPhrase, updateAccessPhrase] = React.useState('');
   const [disableSubmit, updateDisableSubmit] = React.useState(true);
   const errorMessageKey = new URLSearchParams(location.search).get('error');
   const [errorText, setErrorText] = React.useState<string>(StringUtil.isNullOrWhiteSpace(errorMessageKey) ? null : t(`status.accessPhraseRequired.${errorMessageKey}`));

   const sanitizeAccessPhrase = (value: string) => {
      // we do this on any input to clear out an error message from a failed password attempt
      setErrorText(null);
      updateDisableSubmit(StringUtil.isNullOrWhiteSpace(value));
      updateAccessPhrase(value);
   };

   const submitAccessPhrase = () => {
      if (disableSubmit) {
         return;
      }

      (document.getElementById(accessPhraseChallengeFormName) as HTMLFormElement).submit();
   };

   return (
      <>
         <span>
            {t('status.accessPhraseRequired.text')}
         </span>
         <InputAccessPhraseForm
            id={accessPhraseChallengeFormName}
            className="themeable-section"
            method="post"
         >
            <FormFieldRow>
               <TextInput
                  type={inputTypes.text}
                  value={accessPhrase}
                  ariaLabel={t('status.accessPhraseRequired.inputAltText')}
                  errorText={errorText}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => sanitizeAccessPhrase(e.target.value)}
                  onEnter={submitAccessPhrase}
                  themeName={formInputTheme}
                  required={true}
                  tabIndex={0}
                  testId="input-access-phrase"
               />
            </FormFieldRow>
            <FormFieldRow>
               <ControlButton
                  themeName={formInputTheme}
                  label={t('general.submit')}
                  title={t('general.submit')}
                  buttonType={TscButtonType.primary}
                  onClick={() => submitAccessPhrase()}
                  disabled={disableSubmit}
                  testId="submit-access-phrase"
               />
               <input
                  type="hidden"
                  name="accessPhrase"
                  value={StringUtil.sanitizeAccessPhraseSubmit(accessPhrase)}
               />
            </FormFieldRow>
         </InputAccessPhraseForm>
      </>
   );
};

export default AccessPhraseInput;
